/**
 * Blog post registry — central source of truth for /blog and /blog/:slug routes.
 *
 * Each post has bilingual content (ES/EN). Content is an array of section
 * blocks rendered by BlogPostPage. Keep prose tight, scannable, with H2s
 * targeting one keyword cluster each.
 */
import post1 from "./post1_impulsive_decisions";
import post2 from "./post2_mentor_signals";
import post3 from "./post3_emotional_intelligence";
import post4 from "./post4_behavior_patterns";
import post5 from "./post5_ai_for_managers";
import post6 from "./post6_bscan_vs_coach_therapist";
import post7 from "./post7_ai_mentor_vs_coach";
import post8 from "./post8_5_critical_decisions";

export const POSTS = [post1, post2, post3, post4, post5, post6, post7, post8];

export const findPost = (slug, language = "es") =>
  POSTS.find((p) => p.slug.es === slug || p.slug.en === slug) || null;
